const TvPlaylistPageReducer = (state, action) => {
  switch (action.type) {
    case 'PLAYLIST_FETCHING':
      return {...state, isFetching: true};
    case 'PLAYLIST_UPDATE':
      return {...state, isFetching: false, items: action.data.playlist, currentVideo: action.data.currentVideo};
    case 'ADD_PLAYLIST_VIDEO':
      const currentPlaylist = state.items;
      currentPlaylist.push(action.data);
      return {...state, items: currentPlaylist};
    case 'CURRENT_VIDEO_UPDATE':
      return {...state, currentVideo: action.data};
    default:
      return state;
  }
};

export {TvPlaylistPageReducer};
